__turbopack_context__.v({
  "customBackground": "LeadTheFutureCareer-module-scss-module__tkNRTW__customBackground",
  "customContainerInner": "LeadTheFutureCareer-module-scss-module__tkNRTW__customContainerInner",
  "customHeading": "LeadTheFutureCareer-module-scss-module__tkNRTW__customHeading",
  "customSubHeading": "LeadTheFutureCareer-module-scss-module__tkNRTW__customSubHeading",
  "customWhiteBg": "LeadTheFutureCareer-module-scss-module__tkNRTW__customWhiteBg",
  "dropdownHeadVertical": "LeadTheFutureCareer-module-scss-module__tkNRTW__dropdownHeadVertical",
  "heading": "LeadTheFutureCareer-module-scss-module__tkNRTW__heading",
  "headingSelected": "LeadTheFutureCareer-module-scss-module__tkNRTW__headingSelected",
  "headingSubTitle": "LeadTheFutureCareer-module-scss-module__tkNRTW__headingSubTitle",
  "headingTitle": "LeadTheFutureCareer-module-scss-module__tkNRTW__headingTitle",
  "headingWrapper": "LeadTheFutureCareer-module-scss-module__tkNRTW__headingWrapper",
  "headingWrapperInnerSelected": "LeadTheFutureCareer-module-scss-module__tkNRTW__headingWrapperInnerSelected",
  "imageEnd": "LeadTheFutureCareer-module-scss-module__tkNRTW__imageEnd",
  "leadTheFutureContainer": "LeadTheFutureCareer-module-scss-module__tkNRTW__leadTheFutureContainer",
  "leadTheFutureContainerInner": "LeadTheFutureCareer-module-scss-module__tkNRTW__leadTheFutureContainerInner",
  "leadTheFutureDownArrowDown": "LeadTheFutureCareer-module-scss-module__tkNRTW__leadTheFutureDownArrowDown",
  "leadTheFutureDownArrowDownInitital": "LeadTheFutureCareer-module-scss-module__tkNRTW__leadTheFutureDownArrowDownInitital",
  "logoHeadingContainer": "LeadTheFutureCareer-module-scss-module__tkNRTW__logoHeadingContainer",
  "mWebContent": "LeadTheFutureCareer-module-scss-module__tkNRTW__mWebContent",
  "midline": "LeadTheFutureCareer-module-scss-module__tkNRTW__midline",
  "rightContent": "LeadTheFutureCareer-module-scss-module__tkNRTW__rightContent",
});
